import React from 'react';
import Helmet from 'react-helmet';

import {GALLERY_PATH_SEGMENT} from '../../routes/report/reportPaths';
import {RSSLink} from './RSSLink';

export const ReportPageRSSLinks = () => (
  <Helmet>
    <RSSLink pathSegment={GALLERY_PATH_SEGMENT} />
  </Helmet>
);
